(() => {
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let seen = new WeakSet();
  const running = new Set();
  const selector = '.f-reveal, .f-heading, .f-hero__content > *, .f-hero__media, .f-product-card, .f-set-card, .f-formula, .f-video-gallery > article, .f-routine-callout, .f-set-landing__hero > .f-stack, .f-set-landing__image, .f-journal__card, .f-story__media, .f-story__content, .f-content__media, .f-content__body, .f-product-story > .f-stack, .f-product-story__images > .f-media, .f-product-information > .f-stack';
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const enabled = () => root.dataset.motion !== 'off' && !reduced.matches && !window.Shopify?.designMode;
  const observer = new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left);
    visible.forEach((entry, index) => {
      observer.unobserve(entry.target);
      if (!enabled() || entry.target.closest('[hidden], dialog:not([open])')) return;
      const heroImage = entry.target.classList.contains('f-hero__media');
      const animation = entry.target.animate([
        { opacity: heroImage ? .9 : 0, transform: heroImage ? 'scale(1.012)' : 'translateY(18px)' },
        { opacity: 1, transform: 'none' }
      ], { duration: heroImage ? 850 : 700, delay: Math.min(index * 60, 180), easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
      running.add(animation);
      animation.finished.catch(() => {}).finally(() => running.delete(animation));
    });
  }, { threshold: .08, rootMargin: '0px 0px -16px 0px' });
  function init(scope = document) {
    if (!enabled()) return;
    scope.querySelectorAll(selector).forEach(element => {
      if (seen.has(element) || element.closest('dialog, [data-main-cart], [data-gallery], [data-product-root]')) return;
      if (element.parentElement.closest(selector)) return;
      seen.add(element);
      const box = element.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) return;
      observer.observe(element);
    });
  }
  reduced.addEventListener('change', () => {
    if (reduced.matches) { observer.disconnect(); running.forEach(animation => animation.finish()); }
    else { seen = new WeakSet(); init(); }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('focusin', event => running.forEach(animation => { if (animation.effect?.target.contains(event.target)) animation.finish(); }));
  init();
})();
